import React from 'react';
import TextField from '@mui/material/TextField';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  helperText: {
    lineHeight: 1.1,
    letterSpacing: 0,
  },
  sidebarRoot: {
    "& .MuiInputBase-root": {
      border: "1px solid #6D6D6D !important",
      borderRadius: "0",
      padding: "8px 12px",
      fontSize: "16px",
      "&:before, &:after": {
        display: "none !important",
      },
      "&:hover": {
        borderColor: "#333 !important",
        "&:before, &:after": {
          display: "none !important",
        },
      },
      "&.Mui-focused": {
        borderColor: "#6D6D6D !important",
        borderWidth: "1px !important",
        "&:before, &:after": {
          display: "none !important",
        },
      },
    },
    "& .MuiInputBase-input": {
      padding: "0",
    },
    "& .MuiInputLabel-root": {
      display: "none",
    },
  },
}));

const NumberContainer = ({ input, inputId, handleInputs, value, sidebarMode }) => {
  const classes = useStyles();

  let required = input.hasOwnProperty('yup');

  if (input.hasOwnProperty('required')) {
    required = input.required;
  }

  return (
    <TextField
      type="number"
      variant="standard"
      className={sidebarMode ? classes.sidebarRoot : classes.root}
      error={input.error}
      key={inputId}
      name={inputId}
      value={value || ''}
      inputProps={input.inputProps}
      required={required}
      label={input.label}
      helperText={input.error && input.errorMessage}
      onChange={handleInputs}
      FormHelperTextProps={{
        className: classes.helperText
      }}
    />
  );
}

export default NumberContainer;